export const createPacketsEdges = [
  {
    id: "192.168.0.1-214.17.55.99",
    source: "214.17.55.99",
    target: "192.168.0.1",
    type: "straight",
  },
  {
    id: "10.0.0.1-192.168.0.1",
    source: "10.0.0.1",
    target: "192.168.0.1",
    type: "straight",
  },
  {
    id: "10.0.0.1-195.113.76.22",
    source: "10.0.0.1",
    target: "195.113.76.22",
    type: "straight",
  },
  {
    id: "10.0.0.1-192.168.0.1",
    source: "10.0.0.1",
    target: "15.103.46.12",
    type: "straight",
  },
];
